export function Services() {
  return `
    <section id="layanan" class="section">
      <div class="container text-center">

        <h2 class="mb-3">Layanan Kami</h2>
        <p class="text-secondary mb-5">
          Solusi digital untuk kebutuhan bisnis dan personal Anda
        </p>

        <div class="row g-4">

          ${ServiceCard("bi-globe", "Pembuatan Website", "Landing page & web personal modern dan responsif", 0)}
          ${ServiceCard("bi-envelope-paper", "Undangan Digital", "Undangan web & video untuk berbagai acara", 100)}
          ${ServiceCard("bi-printer", "Percetakan", "Cetak banner, brosur, dan kebutuhan lainnya", 200)}
          ${ServiceCard("bi-mortarboard", "Instalasi CBT", "Setup ujian sekolah dengan Garuda CBT", 300)}
          ${ServiceCard("bi-image", "Edit Foto Vektor", "Ubah foto jadi style vector yang keren", 400)}

        </div>

      </div>
    </section>
  `;
}

function ServiceCard(icon, title, desc) {
  return `
    <div class="col-md-4" data-aos="fade-up" data-aos-delay="100">
      <div class="service-card p-4 h-100 text-center">

        <div class="service-icon mb-3">
          <i class="bi ${icon}"></i>
        </div>

        <h5 class="mb-2">${title}</h5>
        <p class="text-secondary small">${desc}</p>

      </div>
    </div>
  `;
}
